<template>
  <div v-cloak>
    <canvas id="hrCanvas" ref="hrCanvas"></canvas>  
  </div>
</template>

<script>
  export default {
    name: 'hrMeter',
    
    props: {
      heartRate: Number,
      user: Object,
    },
    data() {
      return {
        ctx:undefined,
        width:0,
        height:0,
      }
    },
    methods: {
      heartRateScale() {
        const hrs = this.heartRate;
        if (hrs < this.user.zones[0].lower) {
          return this.height - 3;
        }
        else if (hrs > (this.user.maxHR-1)) {
          return 3;
        }
        else {
            return ((this.height * 2) - ((hrs / this.user.maxHR)) * this.height * 2);
        }
      },
      renderHeartRate() {
        const hrs = this.heartRateScale();
        this.ctx.clearRect(0,0,this.width, this.height);
        this.ctx.beginPath();
        this.ctx.moveTo(0, hrs);
        this.ctx.lineTo(this.width, hrs);

        // Draw the Path
        this.ctx.stroke();
      },
    },
    computed: {
    },
    watch: {
        heartRate() {
          this.renderHeartRate();
      }
    },
    mounted() {
      this.$nextTick(function() {
        this.width = this.$refs.hrCanvas.parentNode.parentNode.offsetWidth;
        this.height = this.$refs.hrCanvas.parentNode.parentNode.offsetHeight;
        this.$refs.hrCanvas.width = this.width;
        this.$refs.hrCanvas.height = this.height;
    
        this.ctx = this.$refs.hrCanvas.getContext("2d");
        this.ctx.strokeStyle = "white"
        this.ctx.lineWidth = 6;
        this.renderHeartRate();   


        window.addEventListener("resize",() => {
          if (this.width = this.$refs.hrCanvas != null) {
            this.width = this.$refs.hrCanvas.parentNode.parentNode.offsetWidth;
            this.height = this.$refs.hrCanvas.parentNode.parentNode.offsetHeight;
            this.$refs.hrCanvas.width = this.width;
            this.$refs.hrCanvas.height = this.height;
            this.ctx.strokeStyle = "white"
            this.ctx.lineWidth = 6;
            this.renderHeartRate();   
          }
        })
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
